import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED,
  ACTION_SET_USE_AUTH
} from "./constants";

export interface IFundState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
  useAuth?: boolean;
}

export interface IFundAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
  useAuth?: boolean;
}

const INITIAL_STATE: IFundState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false,
  useAuth: false
}

const applySetIsAppActive = (state: IFundState, action: IFundAction) : IFundState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: IFundState, action: IFundAction) : IFundState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: IFundState, action: IFundAction) : IFundState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const applySetUseAuth = (state: IFundState, action: IFundAction) : IFundState => {
  return {
      ...state,
      useAuth: action.useAuth,
  }
}

const reducerMap: { [actionType: string]: (state: IFundState, action: IFundAction) => IFundState } = {
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FUND)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FUND)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FUND)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.FUND)}${ACTION_SET_USE_AUTH}`]: applySetUseAuth,
};

const fundReducer = (state = INITIAL_STATE, action: IFundAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default fundReducer;
